import React from 'react';
import {Prepend} from "./Prepend";

export default function ConsigneeAddress(props) {
    return (
        <div>
            <div className="form-group">
                <div className="row">
                    <div className="col-sm-2">
                        <div className="input-group">
                            <Prepend value="Zip"/>
                            <input
                                value={props.zip}
                                name="zip"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.zipErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.zipErr}</div>
                        </div>
                    </div>

                    <div className="col-sm-5">
                        <div className="input-group">
                            <Prepend value="Region"/>
                            <input
                                value={props.region}
                                name="region"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.regionErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.regionErr}</div>
                        </div>
                    </div>

                    <div className="col-sm-5">
                        <div className="input-group">
                            <Prepend value="City"/>
                            <input
                                value={props.city}
                                name="city"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.cityErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.cityErr}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-group">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="input-group">
                            <Prepend value="Street"/>
                            <input
                                value={props.street}
                                name="street"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.streetErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.streetErr}</div>
                        </div>
                    </div>

                    <div className="col-sm-2">
                        <div className="input-group">
                            <Prepend value="House"/>
                            <input
                                value={props.house}
                                name="house"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.houseErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.houseErr}</div>
                        </div>
                    </div>

                    <div className="col-sm-2">
                        <div className="input-group">
                            <Prepend value="Corpus"/>
                            <input
                                value={props.corpus}
                                name="corpus"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.corpusErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.corpusErr}</div>
                        </div>
                    </div>

                    <div className="col-sm-2">
                        <div className="input-group">
                            <Prepend value="Apartment"/>
                            <input
                                value={props.apartment}
                                name="apartment"
                                onChange={props.handleChangeBlur}
                                onBlur={props.handleChangeBlur}
                                className={props.apartmentErr ? "form-control is-invalid" : "form-control"}
                            />
                            <div className="invalid-feedback">{props.apartmentErr}</div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}
